// tslint:disable: max-line-length
import { checkStatus, parseJSON } from './utils';

const config = window.config;

const generateHeaders = (locale, Authorization = null) => ({
  Accept: 'application/vnd.intrepid+json; version=2',
  'Accept-Language': locale,
  'Content-Type': 'application/json',
  Authorization
});

export const getMarkers = (locale, authToken, companyId) =>
  fetch(
    `${config.REACT_APP_BASE_URL}/api/travelnavigator/company/${companyId}/location`,
    {
      method: 'GET',
      headers: generateHeaders(locale, authToken)
    }
  )
    .then(checkStatus)
    .then(parseJSON);

export const getCompany = (locale, authToken) =>
  fetch(`${config.REACT_APP_BASE_URL}/api/travelnavigator/me`, {
    method: 'GET',
    headers: generateHeaders(locale, authToken)
  })
    .then(checkStatus)
    .then(parseJSON);



// WEBPACK FOOTER //
// ./src/api/map.js